var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id)?_c('a',{class:_vm.className2,attrs:{"href":"#"},on:{"click":function($event){return _vm.viewMemberDetails($event)}}},[_vm._v(_vm._s(_vm.text))]):_c('span',{class:_vm.className2},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }